import { EditOutlined } from "@ant-design/icons";
import { Button, Tooltip } from "antd";

const PredefinedSmsActions = ({ record, onClick}) => {
  return (
    <>
      {record.id && (
        <Tooltip title="ویرایش">
          <Button icon={<EditOutlined />} type="primary" onClick={() => onClick(record)} />
        </Tooltip>
      )}
    </>
  );
};

export default PredefinedSmsActions;
